import { Controller } from "stimulus";

export default class extends Controller {
  static get targets() {
    return ['content'];
  }

  toggle() {
    this.contentTargets.forEach((t) => {
      t.classList.toggle("u-tilt--left");
      t.classList.toggle("u-tilt--right");
    });
  }
}
